import { Form, InputGroup } from 'react-bootstrap';
import { connect } from 'formik';
import objectPath from 'object-path';
import currencies from '../../../dataObjects/currencies';

function PriceField(props) {
  const { formik } = props;
  const { name } = props;
  const errors = objectPath.get(formik.errors, name);
  const touched = objectPath.get(formik.touched, name);
  const value = objectPath.get(formik.values, name);
  const style = props.style ? props.style : {};

  // Adjust initial value to decimals
  const currency = currencies[props.currency];
  const decimals = currency.decimal_digits ? currency.decimal_digits : 0;
  // eslint-disable-next-line no-restricted-properties
  const multiplier = 10 ** decimals;

  let valueDecimals = value;
  valueDecimals /= multiplier;

  function handleChange(e) {
    let v = e.target.value;
    v *= multiplier;
    v = Math.round(v);
    formik.setFieldValue(name, v);
  }

  return (
    <>
      {props.title && (
        <Form.Label htmlFor={name}>
          {props.title}
          {props.required ? '*' : null}
        </Form.Label>
      )}
      <InputGroup>
        <InputGroup.Text>{currency.symbol}</InputGroup.Text>
        <Form.Control
          style={{ minWidth: 100, ...style }}
          type="number"
          step="0.01"
          name={name}
          id={name}
          onChange={handleChange}
          // onBlur={formik.handleBlur}
          value={valueDecimals}
          isValid={!errors && touched && props.showValid}
          isInvalid={errors && touched}
        />
      </InputGroup>
      {errors && touched ? (
        <div className="invalid-feedback">{errors}</div>
      ) : null}
    </>
  );
}

export default connect(PriceField);
